module.exports = __webpack_public_path__ + "static/media/password.5cddf3ff.svg";